import { SVGProps } from 'react';

type IconProps = {
  className?: string;
  title?: string;
};

const defaultProps = {
  width: 18,
  height: 18,
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 1.6,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
} satisfies SVGProps<SVGSVGElement>;

export function DashboardIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <rect x="3" y="3" width="8" height="8" rx="2" />
      <rect x="13" y="3" width="8" height="5" rx="2" />
      <rect x="13" y="10" width="8" height="11" rx="2" />
      <rect x="3" y="13" width="8" height="8" rx="2" />
    </svg>
  );
}

export function RealtimeIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <path d="M4 16l4-4 3 3 5-6 4 4" />
      <path d="M4 20h16" />
    </svg>
  );
}

export function UsersIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <circle cx="8" cy="8" r="3.5" />
      <path d="M2.5 19a5.5 5.5 0 0 1 11 0" />
      <circle cx="17" cy="9" r="3" />
      <path d="M14.5 19a4.5 4.5 0 0 1 7 0" />
    </svg>
  );
}

export function ExamsIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <rect x="6" y="4" width="12" height="16" rx="2" />
      <path d="M9 4v4h6V4" />
      <path d="M9 12h6" />
      <path d="M9 16h4" />
    </svg>
  );
}

export function CalendarIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <rect x="3" y="5" width="18" height="16" rx="2" />
      <path d="M7 3v4M17 3v4M3 9h18" />
    </svg>
  );
}

export function WindowsIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M3 9h18" />
    </svg>
  );
}

export function AuditIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <path d="M7 3h8l4 4v14H7z" />
      <path d="M15 3v4h4" />
      <path d="M9 13h6M9 17h4" />
    </svg>
  );
}

export function BellIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <path d="M6 17h12l-1-2v-5a5 5 0 0 0-10 0v5l-1 2z" />
      <path d="M9.5 19a2.5 2.5 0 0 0 5 0" />
    </svg>
  );
}

export function NotificationsIcon(props: IconProps) {
  return <BellIcon {...props} />;
}

export function SettingsIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <circle cx="12" cy="12" r="3.5" />
      <path d="M19 12a7 7 0 0 0-.1-1l2-1.5-2-3.5-2.3.6a6.8 6.8 0 0 0-1.7-1L14.5 2h-5l-.4 2.6a6.8 6.8 0 0 0-1.7 1l-2.3-.6-2 3.5 2 1.5a7 7 0 0 0 0 2l-2 1.5 2 3.5 2.3-.6a6.8 6.8 0 0 0 1.7 1l.4 2.6h5l.4-2.6a6.8 6.8 0 0 0 1.7-1l2.3.6 2-3.5-2-1.5c.1-.3.1-.7.1-1z" />
    </svg>
  );
}

export function ShieldIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <path d="M12 3l7 3v6c0 4.5-3 7.8-7 9-4-1.2-7-4.5-7-9V6l7-3z" />
      <path d="M9 12l2 2 4-4" />
    </svg>
  );
}

export function HelpIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <circle cx="12" cy="12" r="9" />
      <path d="M9.5 9a2.5 2.5 0 0 1 5 0c0 2-2.5 2-2.5 4" />
      <circle cx="12" cy="17" r="0.8" />
    </svg>
  );
}

export function CreditCardIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <rect x="3" y="6" width="18" height="12" rx="2" />
      <path d="M3 10h18" />
      <path d="M7 15h4" />
    </svg>
  );
}

export function SlotsIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <path d="M4 7h16M4 12h10M4 17h6" />
      <circle cx="18" cy="12" r="2.5" />
    </svg>
  );
}

export function SearchIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <circle cx="11" cy="11" r="6.5" />
      <path d="M16.5 16.5L21 21" />
    </svg>
  );
}

export function CheckIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <circle cx="12" cy="12" r="9" />
      <path d="M8 12l2.5 2.5 5-5" />
    </svg>
  );
}

export function AlertIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <path d="M12 3l9 16H3z" />
      <path d="M12 9v4" />
      <circle cx="12" cy="17" r="0.8" />
    </svg>
  );
}

export function CarIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <rect x="2" y="8" width="20" height="9" rx="2" />
      <path d="M5 8l2-4h10l2 4" />
      <circle cx="7" cy="17" r="1.5" />
      <circle cx="17" cy="17" r="1.5" />
    </svg>
  );
}

/** Icône formateur : silhouette avec toque de diplômé */
export function InstructorIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <circle cx="12" cy="13" r="4" />
      <path d="M4 21a8 8 0 0 1 16 0" />
      <path d="M7 7l5-3 5 3-5 3-5-3z" />
      <path d="M17 7v4" />
    </svg>
  );
}

/** Icône devis : document avec crayon */
export function QuoteIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
      <path d="M14 3v5h5" />
      <path d="M9 12h6M9 16h4" />
      <path d="M17 16l2-2-2-2" />
    </svg>
  );
}

/** Icône facture : document avec euro */
export function InvoiceIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <path d="M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8z" />
      <path d="M14 3v5h5" />
      <path d="M9 12h6M9 16h6" />
      <circle cx="13" cy="14" r="0" />
    </svg>
  );
}

/** Icône catalogue : grille de produits */
export function CatalogIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <rect x="3" y="3" width="7" height="9" rx="1" />
      <rect x="14" y="3" width="7" height="5" rx="1" />
      <rect x="14" y="12" width="7" height="9" rx="1" />
      <rect x="3" y="16" width="7" height="5" rx="1" />
    </svg>
  );
}

/** Icône demandes / réservations : boîte de réception avec flèche */
export function BookingsIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <path d="M4 4h16v10H4z" rx="1" />
      <path d="M4 14l4 4h8l4-4" />
      <path d="M9 9h6M9 12h4" />
    </svg>
  );
}

/** Icône livret numérique : carnet ouvert avec checkmark */
export function LivretIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <path d="M4 19V5a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v14" />
      <path d="M4 19a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2" />
      <path d="M9 7h6M9 11h6M9 15h4" />
      <path d="M4 19H20" />
    </svg>
  );
}

/** Icône paiements : billet / monnaie */
export function PaymentIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <rect x="2" y="6" width="20" height="13" rx="2" />
      <circle cx="12" cy="12" r="2.5" />
      <path d="M6 9v6M18 9v6" />
    </svg>
  );
}

export function DownloadIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <path d="M12 3v13M7 11l5 5 5-5" />
      <path d="M3 20h18" />
    </svg>
  );
}

export function MailIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <rect x="3" y="5" width="18" height="14" rx="2" />
      <path d="M3 7l9 6 9-6" />
    </svg>
  );
}

export function ChevronRightIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <path d="M9 18l6-6-6-6" />
    </svg>
  );
}

export function ChevronDownIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <path d="M6 9l6 6 6-6" />
    </svg>
  );
}

export function ChevronUpIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <path d="M18 15l-6-6-6 6" />
    </svg>
  );
}

export function BarChartIcon(props: IconProps) {
  return (
    <svg {...defaultProps} className={props.className} aria-hidden>
      <rect x="3" y="12" width="4" height="9" rx="1" />
      <rect x="10" y="7" width="4" height="14" rx="1" />
      <rect x="17" y="3" width="4" height="18" rx="1" />
    </svg>
  );
}
